import React, { useState } from "react";
import "./shortlisted.css";

const ShortlistedView = ({ data = {} }) => {
  const subjects = Object.keys(data);
  const [activeTab, setActiveTab] = useState(subjects[0] || "");
  const [searchInput, setSearchInput] = useState(""); // live search term

  const candidates = data[activeTab] || [];

  const filteredCandidates = candidates.filter((c) =>
    c.name.toLowerCase().includes(searchInput.toLowerCase()) ||
    c.id.includes(searchInput)
  );

  if (!activeTab) {
    return <div className="container">No data available</div>;
  }

  return (
    <div className="container">
      <h1 className="title">🎯 Shortlisted Candidates 2026–27</h1>

      {/* Subject dropdown (replaces tabs) */}
      <div className="subject-select">
        <select
          value={activeTab}
          onChange={(e) => {
            setActiveTab(e.target.value);
            setSearchInput("");
          }}
        >
          {subjects.map((subject) => (
            <option key={subject} value={subject}>
              {subject.replace("_", " ")}
            </option>
          ))}
        </select>
      </div>

      {/* Search input + button */}
      <div className="search-row">
        <input
          type="text"
          placeholder="Search by ID or Name..."
          className="search"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
        />
      </div>

      {/* Table */}
      <div className="table-container">
        <table className="modern-table">
          <thead>
            <tr className="text-center">
              <th className="text-center">No</th>
              <th className="text-center">Candidate Name</th>
              <th className="text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredCandidates.map((candidate) => (
              <tr key={candidate.id}>
                <td>{candidate.id}</td>
                <td>{candidate.name}</td>
                <td>
                  <span className="status">Qualified For Next Phase</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Notice */}
      <div className="notice">
        <h3>Kindly note:</h3>
        <p>
          Shortlisted candidates may get ready for the next phase of the
          Recruitment process in the same week. Further information will be sent
          to your email inbox.
        </p>
        <p className="best">All the best!</p>

        <div className="footer">
          📞 7871770091 | ✉ loyolatechschool@gmail.com | 🌐 www.loyolatechschool.com
        </div>
      </div>
    </div>
  );
};

export default ShortlistedView;